import {List} from 'immutable';

import {updateItem} from '../../paginator/actions';

export const SET_QUESTIONS = 'EXAMINATION_SET_QUESTIONS';
export const ADD_QUESTION = 'EXAMINATION_ADD_QUESTION';
export const REMOVE_QUESTION = 'EXAMINATION_REMOVE_QUESTION';
export const SET_FAKE = 'EXAMINATION_SET_FAKE';
export const SET_COEFFICIENT = 'EXAMINATION_SET_COEFFICIENT';
export const REORDER = 'EXAMINATION_REORDER';

export const SET_LAYOUT = 'EXAMINATION_LAYOUT_SET_LAYOUT';
export const SET_LAYOUT_OPTIONS = 'EXAMINATION_LAYOUT_SET_LAYOUT_OPTIONS';
export const UPDATE_QUESTION_LAYOUT = 'EXAMINATION_LAYOUT_UPDATE_QUESTION_LAYOUT';
export const UPDATE_ANSWER_LAYOUT = 'EXAMINATION_LAYOUT_UPDATE_ANSWER_LAYOUT';
export const ADD_ELEMENT = 'EXAMINATION_LAYOUT_ADD_ELEMENT';
export const UPDATE_SCORE = 'EXAMINATION_LAYOUT_UPDATE_SCORE';
export const REORDER_LAYOUT = 'EXAMINATION_REORDER_LAYOUT';

export const ITEM_TYPE_GLOBAL = -1;
export const ITEM_TYPE_HIDDEN = -2;
export const ITEM_TYPE_STYLE = -4;

export function setQuestions(questions, elementId) {
    return dispatch => dispatch([
        {
            type: SET_QUESTIONS,
            elementId,
            payload: questions,
        },
        {
            type: SET_LAYOUT,
            elementId: elementId + ':layout',
            payload: questions,
        },
    ]);
}

export function updateExamination(examination, examinationsElementId) {
    return updateItem(examination, examinationsElementId + ':paginator');
}

export function addQuestion(question, elementId) {
    return dispatch => dispatch([
        {
            type: ADD_QUESTION,
            elementId,
            payload: question,
        },
        {
            type: ADD_QUESTION,
            elementId: elementId + ':layout',
            payload: question,
        },
    ]);
}

export function removeQuestion(id, elementId) {
    return dispatch => dispatch([
        {
            type: REMOVE_QUESTION,
            elementId: elementId.split(':')[0],
            payload: id,
        },
        {
            type: REMOVE_QUESTION,
            elementId: elementId.split(':')[0] + ':layout',
            payload: id,
        },
    ]);
}

export function setFake(id, fake, elementId) {
    return {
        type: SET_FAKE,
        elementId,
        payload: {id, fake},
    };
}

export function setCoefficient(id, coefficient, elementId) {
    return {
        type: SET_COEFFICIENT,
        elementId,
        payload: {id, coefficient},
    };
}

export function reorder(order, elementId) {
    return dispatch => dispatch([
        {
            type: REORDER,
            elementId: elementId.split(':')[0],
            payload: order,
        },
        {
            type: REORDER_LAYOUT,
            elementId: elementId.split(':')[0] + ':layout',
            payload: order,
        },
    ]);
}

export function setLayoutOptions(options, elementId) {
    return {
        type: SET_LAYOUT_OPTIONS,
        elementId,
        payload: options,
    };
}

export function updateQuestionLayout(question, elementId) {
    return dispatch => dispatch([
        {
            type: UPDATE_QUESTION_LAYOUT,
            elementId: elementId.split(':')[0],
            payload: question instanceof List ? question : new List([question]),
        },
        {
            type: UPDATE_QUESTION_LAYOUT,
            elementId,
            payload: question instanceof List ? question : new List([question]),
        },
    ]);
}

export function updateAnswerLayout(answer, elementId) {
    return dispatch => dispatch([
        {
            type: UPDATE_ANSWER_LAYOUT,
            elementId: elementId.split(':')[0],
            payload: answer instanceof List ? answer : new List([answer]),
        },
        {
            type: UPDATE_ANSWER_LAYOUT,
            elementId,
            payload: answer instanceof List ? answer : new List([answer]),
        },
    ]);
}

export function addElement(page, view, elementId) {
    return {
        type: ADD_ELEMENT,
        elementId,
        payload: {page, view},
    };
}

export function updateScore(questionId, id, score, elementId) {
    return {
        type: UPDATE_SCORE,
        elementId,
        payload: {
            questionId,
            id,
            score,
        },
    };
}
